var localConf = {}
if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging') {
  localConf = require('./local')
}

export const API_URL = localConf.API_URL || process.env.VUE_APP_API_URL
export const STORAGE_KEY = localConf.STORAGE_KEY || process.env.VUE_APP_STORAGE_KEY
export const CLIENT_ID = localConf.CLIENT_ID || process.env.VUE_APP_CLIENT_ID
